import React, { useState, useEffect } from 'react';
import { Divider, Typography, Tabs, Slider, Form, Select, Button } from 'antd';
import './index.less';
import _service from '@netuno/service-client';
import ListServices from './ListServices';

import { FormattedMessage, useIntl } from 'react-intl';
import ServiceSelect from '../../../../components/ServiceSelect';

const { Title } = Typography;
const { Option } = Select;

const langContext = 'reserved-area.marketplace.service';

const marks = {
  25: '25',
  50: '50',
  75: '75',
  100: '100',
  125: '125',
  150: '150',
  175: '175',
  200: '200',
  225: '225',
  250: '250',
  275: '275',
  300: '300',
}

export default () => {
  const [loading, setLoading] = useState(false);
  const [radius, setRadius] = useState(10);
  const [serviceUID, setServiceUID] = useState(null);
  const [speedRadius, setSpeedRadius] = useState(0);
  const [filterCards, setFilterCards] = useState("desc-price");

  useEffect(() => {
    setLoading(false);
  }, []);

  
  const orderingOfCards = (value) => {
    setFilterCards(value);
  }

  const intl = useIntl();

  const handleRadiusChange = (value) => {
    setRadius(value);
  };

  const handleServiceChange = (value) => {
    setServiceUID(value);
  };

  return (
    <>
      <div className="marketplace__service">
        <Title level={2}><FormattedMessage id={`${langContext}.title`} /></Title>
        <Divider />
        <Form.Item label={intl.formatMessage({ id: langContext + '.fields.radius' }) + " (Km)"}>
          <Slider
            min={0}
            marks={marks}
            max={1000}
            onChange={handleRadiusChange}
            step={radius <= 300 ? 25 : 1}
            tooltipVisible />
        </Form.Item>
        <Form.Item label={intl.formatMessage({ id: langContext + '.fields.service' })} >
          <ServiceSelect allowClear onChange={handleServiceChange} placeholder={intl.formatMessage({ id: langContext + '.service-select' })} />
        </Form.Item>
        <Form.Item className='select-price' style={{ width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
          <Select style={{ width: '250px'}} onChange={orderingOfCards} placeholder={intl.formatMessage({ id: langContext + '.order-select' })}>
            <Select.Option value="asc-price" >{intl.formatMessage({ id: langContext + '.fields.crescent-price' })}</Select.Option>
            <Select.Option value="desc-price">{intl.formatMessage({ id: langContext + '.fields.decreasing-price' })}</Select.Option>
            <Select.Option value="asc-date" >{intl.formatMessage({ id: langContext + '.fields.crescent-date' })}</Select.Option>
            <Select.Option value="desc-date">{intl.formatMessage({ id: langContext + '.fields.decreasing-date' })}</Select.Option>
          </Select>
        </Form.Item>
        <Divider />
        <ListServices serviceUID={serviceUID} radius={radius} filterCards={filterCards} />
      </div >
    </>
  );
}
